import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-x-4" };
const _hoisted_2 = {
    key: 0,
    class: "rounded-xl border border-(--border-border-base-medium) bg-(--background-background-white-secondary-soft) p-4 text-sm text-(--text-text-black-default) whitespace-pre-line"
};
import { computed } from "vue";
import { AutoComplete } from "@eudonet/opal";
import { buildAutoCompleteLabels } from "@/shared/composables/autoCompleteLabels";
import { parseAddressQuery } from "../../domain/address-utils";
import { useAddressFormatter } from "@/shared/composables/useAddressFormatter";
import { useAddressSearch } from "../../composables/useAddressSearch";
import { useWorkspaceCountry } from "@/shared/composables/useWorkspaceCountry";
import { hasAddressField, setAddressCountry, toAddressLayout, } from "@/shared/utils/addressFieldConfig";
import AddressDetailsFields from "./AddressDetailsFields.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressFormFields',
    props: /*@__PURE__*/ _mergeModels({
        errors: {},
        readonly: { type: Boolean }
    }, {
        "details": { required: true },
        "detailsModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["blur"], ["update:details"]),
    setup(__props, { expose: __expose }) {
        const details = _useModel(__props, "details");
        const layout = useWorkspaceCountry();
        const hasHouseNumberField = computed(() => hasAddressField(layout.value, "houseNumber"));
        const addressFormatter = useAddressFormatter();
        function onFieldUpdate(key, value) {
            if (key === "country")
                setAddressCountry(details.value, value, layout.value);
            else
                details.value[key] = value;
        }
        // BAN-backed autocomplete on the Adresse (line1) field — same source of truth as the
        // inline address fields (CreateOrganisationModal / ResidentIdentificationForm). Lets the
        // user search/replace the whole address from within the field instead of typing it raw.
        const { suggestions: addressSuggestions, loading: addressLoading, search: runAddressSearch, clear: clearAddressSearch, } = useAddressSearch();
        function onAddressSearch(query) {
            details.value.line1 = query;
            runAddressSearch(query);
        }
        // A BAN suggestion carries the full "street, postalCode city" label; keep only the street in
        // line1 and route postalCode / city to their dedicated fields (country comes from the meta —
        // BAN is France-only). line2/line3 are the user's manual details and stay untouched.
        function onAddressSelect(option) {
            const parsed = parseAddressQuery(option.value);
            details.value.line1 = parsed.line1 ?? option.value;
            const postalCode = option.meta?.postalCode ?? parsed.postalCode;
            const city = option.meta?.city ?? parsed.city;
            if (postalCode)
                details.value.postalCode = postalCode;
            if (city)
                details.value.city = city;
            if (option.meta?.country)
                details.value.country = option.meta.country;
        }
        const preview = computed(() => addressFormatter.parts(toAddressLayout(details.value, layout.value)).join("\n"));
        __expose({ clearSuggestions: clearAddressSearch });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AddressDetailsFields, {
                    form: details.value,
                    country: _unref(layout),
                    disabled: __props.readonly,
                    errors: __props.errors,
                    onUpdate: onFieldUpdate,
                    onBlur: _cache[2] || (_cache[2] = (key) => _ctx.$emit('blur', key))
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                    (!hasHouseNumberField.value)
                        ? {
                            name: "line1",
                            fn: _withCtx(() => [
                                _createVNode(_unref(AutoComplete), _mergeProps(_unref(buildAutoCompleteLabels)(_ctx.$t), {
                                    modelValue: details.value.line1,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((details.value.line1) = $event)),
                                    label: _ctx.$t('organisation.detail.mainInformation.addressLine1'),
                                    placeholder: _ctx.$t('organisation.detail.mainInformation.addressPlaceholder'),
                                    required: true,
                                    error: __props.errors?.line1,
                                    options: _unref(addressSuggestions),
                                    loading: _unref(addressLoading),
                                    disabled: __props.readonly,
                                    "keep-input-on-edit": "",
                                    "full-width": "",
                                    onSearch: onAddressSearch,
                                    onSelect: onAddressSelect,
                                    onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('blur', 'line1')))
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "label", "placeholder", "error", "options", "loading", "disabled"])
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["form", "country", "disabled", "errors"]),
                (preview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(preview.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
